import { Component, EventEmitter, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import {
  AutoCompleteSelectionItem,
  AutocompleteRemoteTableComponent,
} from '../../../core/component/autocomplete-remote-table/autocomplete-remote-table.component';
import { FormControlExFactory } from '../../../core/service/factory/form-control-ex-factory.service';
import { ColumnDefinitionFactory } from '../../../core/service/factory/column-definition-factory.service';
import { getAstralDropdownOverlayPositions } from '../../../core/component/astral-components/astral-dropdown-overlay.util';
import { Contact } from '../../model/contact';

@Component({
    selector: 'app-representatives-filter-table',
    templateUrl: './representatives-filter-table.component.html',
    styleUrls: ['./representatives-filter-table.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class RepresentativesFilterTableComponent<TData = Contact, TOptions = any>
  extends AutocompleteRemoteTableComponent<TData, TOptions>
  implements OnInit
{
  constructor(
    fcf: FormControlExFactory,
    private _columnFactory: ColumnDefinitionFactory
  ) {
    super(fcf);
  }

  @Output() selectedContact = new EventEmitter<Contact>();
  @Output() nextPageTrigger = new EventEmitter<void>();

  /** Renders above overflowing accordion content rather than being clipped by it. */
  readonly overlayPositions = getAstralDropdownOverlayPositions();

  ngOnInit(): void {
    super.ngOnInit();

    this.columnDefinition = [
      this._columnFactory.create('TENANT.CONTACT_NUMBER', 'data.number'),
      this._columnFactory.create('TENANT.NAME', 'data.name'),
      this._columnFactory.create('TENANT.PHONE', 'data.phone'),
      this._columnFactory.create('TENANT.EMAIL', 'data.email'),
    ];
  }

  // onOptionSelected analogue
  onRowClick(e: { context: AutoCompleteSelectionItem<TData>; event: any }): void {
    this.setControlValue(e.context);
    this.closePopup();
    this.selectedContact.emit(e.context.data as Contact);
  }

  onButtonClick(): void {
    this.closePopup();
    this.selectedContact.emit(null);
  }

  handleNextPage(): void {
    this.nextPage();
  }
}
